


































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Game} from "@/models/Game";
import {Player} from "@/models/Player";

@Component
export default class TheNamesInput extends Vue {

    @Prop()
    game: Game;

    private mutableGame: Game;

    created() {
        this.players = this.game.players;
        this.mutableGame = this.game;
    }
    private players: Player[] = [];

    private isValid = true;

    private backToNumberOfPlayersSelector() {
        this.$emit('back-to-number-of-players-selector')
    }

    private startGame() {
        this.mutableGame.players = this.players;
        this.$emit('update-game', this.mutableGame);
        this.$emit('start-game');
    }
}
